export const wishlistLocalStorageKey = 'wishlist'

export default {
  namespaced: true,
  state () {
    return {
      productIDs: []
    }
  },
  mutations: {
    setProductIDs (state, productIDs) {
      state.productIDs = productIDs
    },
    addProductID (state, productID) {
      state.productIDs = [productID].concat(state.productIDs.filter(id => id !== productID))
    },
    removeProductID (state, productID) {
      state.productIDs = state.productIDs.filter(id => id !== productID)
    }
  },
  actions: {
    initialize ({ commit }) {
      if (localStorage.getItem(wishlistLocalStorageKey)) {
        commit('setProductIDs', JSON.parse(localStorage.getItem(wishlistLocalStorageKey)))
      }
    },
    addProductID ({ commit }, productID) {
      commit('addProductID', productID)
    },
    removeProductID ({ commit }, productID) {
      commit('removeProductID', productID)
    }
  },
  getters: {
    hasProductID: state => productID => state.productIDs.some(item => item === productID)
  }
}
